import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

//计费模型
export const getPrice = (params) => { return req("get", "/admin/price") };

export const getPriceByid = (params) => { return req("get", "/admin/getPriceByid?"+getHttpParams(params))};


//新增
export const addPrice = (params) => { return req("post", "/admin/price/add",params) };

export const updatePrice = (id, params) => { return req("post", "/admin/price/updateModel",params) };

export const deletePrice = (id) => { return req("delete", "/admin/price/"+id) };

//充电订单列表
export const getChageOrders = (params) => { return req("get", "/admin/getChageOrders?"+getHttpParams(params))};

export const getChageOrdersUrl = (params) => { return  "/admin/getChageOrders?"+getHttpParams(params)};

//充值订单列表
export const getReChargeOrders = (params) => { return req("get", "/admin/getReChargeOrders?"+getHttpParams(params))  };

export const closeChargeOrder = (params) => { return req("get", "/admin/closeChargeOrder?"+getHttpParams(params))  };


export const getReChargeOrdersUrl = (params) => { return  "/admin/getReChargeOrders?"+getHttpParams(params)};



//用户列表
// per_page: 30
// page: 1
export const getUser = (params) => { return req("get", "/admin/wxUser?"+getHttpParams(params))  };

export const updateAppUser = (id, params) => { return req("patch", "/admin/wxUser/"+id+'?'+getHttpParams(params)) };

export const updateAppUserFee = (id, params) => { return req("get", "/admin/cutFee?"+getHttpParams(params)) };

export const addWhiteUser = (params) => { return req("get", "/admin/addWhiteUser?"+getHttpParams(params))  };

export const deleteWhiteUser = (params) => { return req("get", "/admin/deleteWhiteUser?"+getHttpParams(params))  };

export const get_suppliers_name = (params) => { return req("get", "/admin/get_suppliers_name") };






// WEBPACK FOOTER //
// ./src/api/price.js